module.exports = __webpack_public_path__ + "static/media/bevege.7d617675.mp3";